var map = {
	"./accounts.json": 91978,
	"./admin.json": 7969,
	"./api.json": 10270,
	"./applicant.json": 40960,
	"./auth.json": 7892,
	"./billing.json": 10261,
	"./camera.json": 89057,
	"./categories.json": 1690,
	"./common.json": 70503,
	"./company-settings.json": 99297,
	"./contact-us.json": 45913,
	"./currencies.json": 74357,
	"./dashboard.json": 57090,
	"./data-sources.json": 34553,
	"./doc-verification.json": 36000,
	"./documents.json": 90728,
	"./error-boundary.json": 64437,
	"./event.json": 31638,
	"./file-size.json": 88026,
	"./files-uploader.json": 94274,
	"./filters.json": 28005,
	"./google.json": 23977,
	"./manual-fields.json": 73570,
	"./navigation.json": 85748,
	"./onboarding.json": 87651,
	"./pagination.json": 48114,
	"./payment.json": 84980,
	"./pep.json": 2887,
	"./poa-gen.json": 51097,
	"./regions.json": 36779,
	"./requirements.json": 74802,
	"./roles.json": 79279,
	"./settings-menu.json": 21393,
	"./table.json": 29710,
	"./tags.json": 92855,
	"./user-settings.json": 70445,
	"./validation.json": 50833,
	"./verification-profiles.json": 61242,
	"./welcome-modal.json": 18530,
	"./white-label.json": 81136,
	"./widget-demo.json": 55754,
	"lang/locales/en/accounts.json": 91978,
	"lang/locales/en/admin.json": 7969,
	"lang/locales/en/api.json": 10270,
	"lang/locales/en/applicant.json": 40960,
	"lang/locales/en/auth.json": 7892,
	"lang/locales/en/billing.json": 10261,
	"lang/locales/en/camera.json": 89057,
	"lang/locales/en/categories.json": 1690,
	"lang/locales/en/common.json": 70503,
	"lang/locales/en/company-settings.json": 99297,
	"lang/locales/en/contact-us.json": 45913,
	"lang/locales/en/currencies.json": 74357,
	"lang/locales/en/dashboard.json": 57090,
	"lang/locales/en/data-sources.json": 34553,
	"lang/locales/en/doc-verification.json": 36000,
	"lang/locales/en/documents.json": 90728,
	"lang/locales/en/error-boundary.json": 64437,
	"lang/locales/en/event.json": 31638,
	"lang/locales/en/file-size.json": 88026,
	"lang/locales/en/files-uploader.json": 94274,
	"lang/locales/en/filters.json": 28005,
	"lang/locales/en/google.json": 23977,
	"lang/locales/en/manual-fields.json": 73570,
	"lang/locales/en/navigation.json": 85748,
	"lang/locales/en/onboarding.json": 87651,
	"lang/locales/en/pagination.json": 48114,
	"lang/locales/en/payment.json": 84980,
	"lang/locales/en/pep.json": 2887,
	"lang/locales/en/poa-gen.json": 51097,
	"lang/locales/en/regions.json": 36779,
	"lang/locales/en/requirements.json": 74802,
	"lang/locales/en/roles.json": 79279,
	"lang/locales/en/settings-menu.json": 21393,
	"lang/locales/en/table.json": 29710,
	"lang/locales/en/tags.json": 92855,
	"lang/locales/en/user-settings.json": 70445,
	"lang/locales/en/validation.json": 50833,
	"lang/locales/en/verification-profiles.json": 61242,
	"lang/locales/en/welcome-modal.json": 18530,
	"lang/locales/en/white-label.json": 81136,
	"lang/locales/en/widget-demo.json": 55754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78658;